import template from './upcoming_birthdays_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class UpcomingBirthdaysHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class UpcomingBirthdaysHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new UpcomingBirthdaysHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'UpcomingBirthdaysHelp',
	dialog_class: UpcomingBirthdaysHelpPage,
	template: template,
	template_filename: 'translation/dialogs/upcoming_birthdays_help',
	provider: 'ps'
};
